import React from 'react';
import moment from 'moment';
import {
    ADMIN_LK,
    USER_LK,
} from '@constants';
import {
    DateText,
    MessageItem,
    MessageText,
    NameText,
    TimeText,
    TimeWrapper,
} from '../Message.style';
import { useSelector } from 'react-redux';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { TextWithLinks } from "@components";

const dateFormat = "D MMMM YYYY";

const Message = ({
    date,
    admin_name,
    text,
    time,
    sender,
    show_date,
    loading = false,
    failed = false,
}) => {
    const { t } = useTranslation();

    return (
        <>
            <MessageItem sender={sender}>
                <TimeWrapper>
                    {sender === ADMIN_LK &&
                        <NameText>{admin_name}</NameText>
                    }
                    {!failed &&
                        <TimeText>
                            {loading ? t("message.sending") : time}
                        </TimeText>
                    }
                </TimeWrapper>
                {failed && <ExclamationCircleOutlined />}
                <MessageText>
                    <TextWithLinks text={text} />
                </MessageText>
            </MessageItem>
            {show_date && <DateText>{date}</DateText>}
        </>
    );
};

const ChatMessage = ({
    items,
    item,
    index,
    device_info,
}) => {
    const { auth } = useSelector((state) => state);
    const { user_id } = auth.user;

    return (
        <Message
            show_date={
                moment.unix(item.sent_at).date() !==
                moment.unix(items[index + 1]?.sent_at).date()
            }
            sender={
                (item.sender_id === user_id ||
                    item.sender_id === device_info)
                    ? USER_LK
                    : ADMIN_LK
            }
            admin_name={item.sender_name}
            text={item.content}
            date={moment.unix(item.sent_at).format(dateFormat)}
            time={moment.unix(item.sent_at).format("LT")}
            loading={item.loading}
            failed={item.failed}
        />
    );
}

export default ChatMessage;